import { useFeatureFlagEnabled } from 'posthog-js/react';

import { MEMORY_MAP_POSTHOG_FLAG } from '../constants/posthogFeatureFlags';
import { isMemoryMapLocalOverrideEnabled } from '../utils/featureFlags';

/**
 * Whether the Memory Map workspace feature is available.
 *
 * - Local override (DEV, VITE_ENABLE_MEMORY_MAP, or localStorage) forces **on**.
 * - Otherwise requires PostHog flag `memory_map` === true. While the flag value is
 *   still `undefined` (loading) and there is no local override, this returns **off**.
 */
export function useMemoryMapEnabled(): { enabled: boolean } {
  const flag = useFeatureFlagEnabled(MEMORY_MAP_POSTHOG_FLAG);
  const local = isMemoryMapLocalOverrideEnabled();
  const enabled = local || flag === true;
  return { enabled };
}
